import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

export class InputStammdatenPostItDetails<T extends EMode = EMode.entity> {
  /** Alias: body */
  body?: string;

  __typename?: string;
}

const fields: FieldDefinitions<InputStammdatenPostItDetails> = {
  body: {
    alias: 'body',
  },
  __typename: {
    alias: '__typename',
  },
};

export const inputStammdatenPostItDetailsEntityDefinition: EntitiyDefinition<InputStammdatenPostItDetails> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'InputStammdatenPostItDetails',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
